import api from "./api"

export const getUnitMeasure = async () => {
  return await api.get("/unit-of-measure")
}

export const createAnalitos = async (request) => {
  return await api.post("/analyte", request)
}
export const listAnalytesCreated = async (
  nPage,
  anlt_cname,
  status,
  order,
  cSearchText,
) => {
  return await api.get(
    `/analyte?page=${nPage || 1}&per_page=20${anlt_cname || ""}${status || ""}${
      order || ""
    }${cSearchText || ""}`,
  )
}

export const listResultOptions = async () => {
  return await api.get("/result-option")
}
export const createResultOption = async (result) => {
  return await api.post("/result-option", result)
}

export const listSectors = async () => {
  return await api.get("/sector")
}
export const createSector = async (sector) => {
  return await api.post("/sector", sector)
}

export const listAnalyteId = async (id) => {
  return await api.get(`/analyte/${id}`)
}

export const listHistoryAnalyte = async (id, nPerPage, search_type, text_type) => {
  return await api.get(
    `/history?target_ctype=analyte&target_nid=${id}&${search_type || ""}${
      text_type || ""
    }page=${nPerPage}`,
  )
}

export const listHistoryEquipment = async (id, nPerPage, search_type, text_type) => {
  return await api.get(
    `/history?target_ctype=equipment&target_nid=${id}${search_type || ""}${
      text_type || ""
    }&page=${nPerPage}`,
  )
}

export const listAnalytes = async (cname, bstatus, page, perPage) => {
  const queryParams = new URLSearchParams()

  page && queryParams.append("page", page)
  cname && queryParams.append("cname", cname)
  typeof bstatus === "boolean" && queryParams.append("bstatus", bstatus ? 1 : 0)
  perPage && queryParams.append("per_page", perPage)

  const url = `/analyte?${queryParams.toString()}`
  return await api.get(url)
}

export const editAnalyte = async (id, objUpdate) => {
  return await api.put(`/analyte/${id}`, objUpdate)
}

export const historyType = async () => {
  return await api.get("/analyte-history-type")
}

// ========================================= EQUIPAMENT

export const createEquipament = async (objCreate) => {
  return await api.post("/equipment", objCreate)
}

export const getListEquipament = async (nPage, cname, status, order) => {
  return await api.get(
    `/equipment?page=${nPage || 1}&per_page=20&${cname || ""}${status}${order || ""}`,
  )
}

export const getEquipament = async (id) => {
  return await api.get(`/equipment/${id}`)
}

export const uptadeEquipament = async (id, objCreate) => {
  return await api.put(`/equipment/${id}`, objCreate)
}

export const getWestGardRoles = async () => {
  return await api.get(`/westgard-rule`)
}

export const duplicatedEquipment = async (id) => {
  return await api.post(`/equipment/${id}/replicate`)
}

// ========================================= CONTROL

export const createControl = async (objCreate) => {
  return await api.post(`/control`, objCreate)
}
export const updateControl = async (id, objCreate) => {
  return await api.put(`/control/${id}`, objCreate)
}

export const getControl = async (id) => {
  return await api.get(`/control/${id}`)
}

export const fnListControls = async (nPage, cname, status, order) => {
  return await api.get(
    `/control?page=${nPage || 1}&per_page=20&${cname || ""}${status}${order || ""}`,
  )
}

export const listHistory = async (
  id,
  nPerPage,
  search_type,
  text_type,
  ctype = "control",
) => {
  return await api.get(
    `/history?target_ctype=${ctype}&target_nid=${id}&${search_type || ""}${
      text_type || ""
    }&page=${nPerPage}&per_page=20`,
  )
}
export const listHistoryLaunched = async (
  id,
  nPerPage,
  search_type,
  text_type,
  subtarget_nid,
) => {
  return await api.get(
    `/history?target_ctype=equipment&search_type=launched&target_nid=${id}&${
      search_type || ""
    }${text_type || ""}&page=${nPerPage}&perPage=20&subtarget_nid=${subtarget_nid}`,
  )
}

// ========================================= STEP

export const checkingStep = async () => {
  return await api.get(`/step-check`)
}

export const equipmentsMinimal = async () => {
  return await api.get(`/equipment-minimal`)
}

export const equipmentAnalyteLaunch = (id, order, runLimit = 10) => {
  return api.get(
    `/equipment/${id}/analyte-launch?sort_order=${order}&run_limit=${runLimit}`,
  )
}

export const postRelease = (id, obj) => {
  return api.post(`/equipment/${id}/analyte-launch`, obj)
}

export const equipmentAnalyteLaunchDetails = (equipmentId, analyteId) => {
  return api.get(`/equipment/${equipmentId}/analyte-launch/details/${analyteId}`)
}

// type = prev | next
export const analyteLaunchSkip = (equipmentId, analyteId, runNumber, type = "prev") => {
  return api.get(
    `/equipment/${equipmentId}/analyte-launch/skip?anlt_nid=${analyteId}&run_number=${runNumber}&type=${type}`,
  )
}

export const equipmentAnalyteLaunchRuns = (
  equipmentId,
  analyteId,
  nPage = 1,
  nPerPage = 10,
  startDate = null,
  endDate = null,
) => {
  const params = new URLSearchParams()
  params.append("page", nPage)
  params.append("per_page", nPerPage)
  startDate && params.append("start_date", startDate)
  endDate && params.append("end_date", endDate)
  return api.get(`/equipment/${equipmentId}/analyte-launch/runs/${analyteId}?${params}`)
}

export const equipmentAnalyteLaunchRunsByControlLevel = (
  equipmentId,
  analyteId,
  nLevel,
) => {
  return api.get(
    `/equipment/${equipmentId}/analyte-launch/runs/${analyteId}/level/${nLevel}`,
  )
}

export const equipmentAnalyteControlCalc = (equipmentId, analyteId, controlId, body) => {
  return api.post(
    `/equipment/${equipmentId}/analyte/${analyteId}/control/${controlId}/calc`,
    body,
  )
}

// ========================================= RELEASE

export const getCauses = async () => {
  return await api.get("/cause")
}
export const postCause = async (cause) => {
  return await api.post("/cause", cause)
}

export const putRun = async (id, cause) => {
  return await api.put(`/run/${id}`, cause)
}
export const getRun = async (id) => {
  return await api.get(`/run/${id}`)
}

export const deleteRun = async (id) => {
  return await api.delete(`/run/${id}`)
}

export const postReleaseAll = async (id) => {
  return await api.post(`/equipment/${id}/release-all`)
}

export const getAnalyteLaunch = async (id, params) => {
  return await api.get(`/equipment/${id}/analyte-launch/index?${params}`)
}

export const getVariableBiologic = async () => {
  return await api.get("/biological-variation")
}

export const updateLaunch = async (ob, id) => {
  return await api.put(`/launch/${id}`, ob)
}

export const updateLaunchObservation = async (nLaunchId, cObservation) => {
  return await api.put(`/launch/${nLaunchId}/observation`, { cobservation: cObservation })
}

export const verifyLaunchHasManualAverage = async (aLaunchNids, cParams = null) => {
  return await api.get(
    `/launch/has-manual-average/${aLaunchNids}${cParams ? `?${cParams}` : ""}`,
  )
}

export const unreleaseRun = async (nRunId) => {
  return await api.post(`/run/${nRunId}/unrelease`)
}

// ========================================= DASHBOARD

export const getDashboardTopCauses = async (startDate, endDate, equipmentId) => {
  const paramstStartDate = startDate ? `&start_date=${startDate}` : ""
  const paramstEndDate = endDate ? `&end_date=${endDate}` : ""
  const paramId = equipmentId ? `&equipment_nid=${equipmentId}` : ""

  const params = `${paramstStartDate}${paramstEndDate}${paramId}`
  return await api.get(`/dashboard/top-causes${params ? `?${params}` : ""}`)
}

export const getControlExpiring = async (cParams) => {
  return await api.get(`/control-expiring?${cParams}`)
}

export const getControlExpired = async () => {
  return await api.get(`/control-expired`)
}

export const getChartAttentionPoinst = async (startDate, endDate, equipmentId) => {
  const paramstStartDate = startDate ? `start_date=${startDate}` : ""
  const paramstEndDate = endDate ? `&end_date=${endDate}` : ""
  const paramId = equipmentId ? `&equipment_nid=${equipmentId}` : ""

  const params = `${paramstStartDate}${paramstEndDate}${paramId}`

  return await api.get(
    `/dashboard/attention-points${
      params
        ? `?${params}&alert=1&rejection=1&non_compliance=1`
        : "?alert=1&rejection=1&non_compliance=1"
    }`,
  )
}
export const getEquipmentAttentionPoinst = async () => {
  return await api.get(`/dashboard/equipment-attention-points`)
}

export const getAnaliteByEquipment = async (eqp_id) => {
  return await api.get(`/equipment-analytes${eqp_id ? `?equipment_id=${eqp_id}` : ""}`)
}

export const getAllEquipments = async () => {
  return await api.get(`/equipment?paginated=0`)
}

// incomplete runs alert
export const verifyIncompleteRuns = async () => {
  return await api.get(`/temp-launch-available`)
}

export const incompleteRunsList = async (page = 1) => {
  return await api.get(`/temp-launch${page ? `?page=${page}` : ""}`)
}

export const completeRuns = async () => {
  return await api.post(`/finish-temp-launch`)
}

// REPORTS
export const generateReport = async (oParams) => {
  const { equipments, analytes, ...rest } = oParams
  const params = new URLSearchParams()

  try {
    equipments.forEach((value) => params.append("equipments[]", value))
    analytes.forEach((value) => params.append("analytes[]", value))
    Object.keys(rest).forEach((key) => params.append(key, rest[key]))
  } catch (e) {
    console.log(e)
  }

  return await api.get(`report/generate?${params.toString()}`)
}
